<template>
  <div id="embed_video">
    <div v-if="!show404 && !show403" class="player_video">
      <!-- <uep-player v-if='!isLoading&&token' :video-file-name="token" :query="query" @readyPlayer="readyPlayer"></uep-player> -->
    <iframe
        allow="fullscreen;autoplay"
        mozallowfullscreen="true"
        frameborder="0"
        webkitallowfullscreen="true"
        v-if="!isLoading && crypttext"
        :src="crypttext"
      ></iframe>
   </div>
    <page404 v-if="show404 && !show403"></page404>
    <page403 v-if="show403"></page403>
  </div>
</template>
<script>
import LoadingScreen from "./Loading.vue";
import Page404 from "./404.vue";
import Page403 from "./403.vue";
export default {
  name: "embed_video",
  components: { LoadingScreen, Page404, Page403 },
  data() {
    return {
      crypttext: null,
      skin: "",
      plugin: "",
      query: {},
      token: "",
      isLoading: true,
      show404: false,
      show403: false
    };
  },
  computed: {
    isGV() {
      return window.process.env.IS_GV;
    },
    isFDR() {
      return window.process.env.IS_FDR;
    }
  },
  methods: {
    readyPlayer(param) {
    },
    fetchVideoEmbed(token) {
      let self = this;
      let referer = document.referrer.split("/")[2]
        ? document.referrer.split("/")[2]
        : document.referrer;
      this.$service
        .getCryptedUrlByToken({ uid: token, referer: referer })
        .then(
          function(resp) {
            if (resp.data.allow !== undefined && !resp.data.allow) {
              this.show403 = true;
            } else {
              self.crypttext =
                "https:" +
                window.process.env.PLAYER_INGRESS +
                "/" +
                resp.data.crypted +
                "?";
              for (const key in this.$route.query) {
                self.crypttext =
                  self.crypttext + key + "=" + this.$route.query[key] + "&";
              }
              let defaultQuery = ["skin", "plugin"];
              defaultQuery.forEach(d =>    {
                if (!Object.keys(this.$route.query).includes(d)) {
                  self.crypttext = self.crypttext+ d + "=" + resp.data[d]+"&";
                }
              }
              );
              if (self.crypttext.slice(-1) === "&"){
                self.crypttext =self.crypttext.slice(0, -1);
              }
              if (this.$route.query.token) {
                self.crypttext =
                  self.crypttext + "&token=" + this.$route.query.token;
              }
              if (referer) {
                self.query.referer = referer;
                self.crypttext = self.crypttext + "&referer=" + referer;
              }
              self.isLoading = false;
              if (!resp.data.exist) {
                self.$router.push({ name: "Page404" });
              }
            }
          }.bind(this)
        )
        .catch(
          function(error) {
            self.isLoading = false;
            self.show404 = true;
          }.bind(this)
        );
    }
  },
  created() {
    this.token = this.$route.params.token;
    this.query = Object.assign(
      {
        skin: "dark",
        plugin: "navigation",
        token: this.$route.query.token ? this.$route.query.token : this.token
      },
      this.$route.query
    );
    if (this.$route.query.op && this.$route.query.op === "1") {
      this.query.withoutApi = true;
    } else {
      this.query.withoutApi = false;
    }
    let referer = document.referrer.split("/")[2]
      ? document.referrer.split("/")[2]
      : document.referrer;
    if (referer) {
      this.query.referer = referer;
    }
    this.show404 = false;
    this.show403 = false;
    this.isLoading = false;
    this.fetchVideoEmbed(this.$route.params.token);
  }
};
</script>
<style lang="scss">
div#embed_video,
.player_video {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/EmbedVideoByTocken.vue